import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=292110cc&scoped=true&"
import script from "./AdminConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminConfig.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292110cc",
  null
  
)

export default component.exports